import { styled } from 'stitches.config'

export const PremadeMealsRoot = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '$accent-white',
  width: '100%',
})

export const Wrapper = styled('div', {
  width: '$max',
  padding: '$6 $3',

  '@bp2': {
    padding: '$8 $6',
  },

  '@bp3': {
    padding: '$8 $11',
  },
})

export const ImageBlock = styled('div', {
  flex: 1,
  position: 'relative',

  '@bp3': {
    height: '296px',
  },
})

export const DesktopImageContainer = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'block',
    position: 'absolute',
    top: '-$15',
  },

  '@bp3': {
    top: '-$10',
  },
})

export const MobileImageContainer = styled('div', {
  '& img': {
    maxHeight: '327px',
    '@bp2': {
      maxHeight: 'none',
    },
  },

  '@bp2': {
    display: 'none',
  },
})

export const TextWrapper = styled('div', {
  flex: 2,
  display: 'flex',

  '@bp2': {
    paddingLeft: '$4',
  },

  '@bp3': {
    paddingLeft: '$4',
  },
})

export const ScrollTopButton = styled('button', {
  display: 'none',

  '@bp2': {
    display: 'block',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',

    '& svg': {
      size: '$8',
      color: '$tertiary-200',
    },
  },
})
